import Menu from '@/global/components/MenuV2'
import { CidadesEstado, estadosV2, getCidadesByUf } from '@acme/common'
import { Divider, Grid } from '@mui/material'
import { FormField, FormFieldAutocomplete } from 'global/components/Form'
import { useEffect, useLayoutEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { Api } from 'service/api'

interface CidadeTrabalho {
    uf: string
    cidade: string
    ibge: number
}

interface IProps {
    noDivider?: boolean
    className?: string
}

export function Endereco({ noDivider, className }: IProps) {
    const { watch, setValue } = useFormContext()
    const [cidades, setCidades] = useState<CidadesEstado[]>([])
    const [cidadeTrabalho, setCidadeTrabalho] = useState<CidadeTrabalho | null>(
        null,
    )
    const uf = watch('uf')

    async function getCidadeTrabalho(id: number) {
        const res = await Api.cidade.getById(id)

        setValue('uf', res.uf)
        setValue('Cidade', {
            uf: res.uf,
            cidade: res.cidade,
            ibge: res.ibge,
        })

        const cidades = await getCidadesByUf(res.uf)
        setCidades(cidades)
        setCidadeTrabalho({
            uf: res.uf,
            cidade: res.cidade,
            ibge: res.ibge,
        })
    }

    useEffect(() => {
        const cidadeTrabalho = watch('cidadeTrabalho')
        if (cidadeTrabalho) {
            getCidadeTrabalho(cidadeTrabalho)
        }
    }, [])

    useLayoutEffect(() => {
        ;(async () => {
            if (uf !== undefined) {
                const cidades = await getCidadesByUf(uf)
                setCidades(cidades)
            }
        })()
    }, [setValue, uf])

    function UFFuncionario() {
        if (cidadeTrabalho) {
            return (
                <FormField
                    required
                    name="uf"
                    label="Estado"
                    defaultValue={cidadeTrabalho.uf}
                    select
                >
                    {estadosV2.map(({ id, sigla, nome }) => (
                        <Menu.Item key={id} value={sigla}>
                            {nome}
                        </Menu.Item>
                    ))}
                </FormField>
            )
        } else {
            return (
                <FormField required name="uf" label="Estado" select>
                    {estadosV2.map(({ id, sigla, nome }) => (
                        <Menu.Item key={id} value={sigla}>
                            {nome}
                        </Menu.Item>
                    ))}
                </FormField>
            )
        }
    }

    function CidadeFuncionario() {
        if (cidadeTrabalho && cidades.length > 0) {
            return (
                <FormFieldAutocomplete
                    name="Cidade"
                    label="Cidade"
                    options={cidades.map(cidade => ({
                        cidade: cidade.nome,
                        uf: cidade.uf,
                        ibge: cidade.id,
                    }))}
                    getOptionLabel={option => option.cidade}
                    defaultValue={cidadeTrabalho}
                    required
                />
            )
        } else {
            return (
                <FormFieldAutocomplete
                    name="Cidade"
                    label="Cidade"
                    options={cidades.map(cidade => ({
                        cidade: cidade.nome,
                        uf: cidade.uf,
                        ibge: cidade.id,
                    }))}
                    getOptionLabel={option => option.cidade}
                    required
                />
            )
        }
    }

    return (
        <section id="endereço" className={className}>
            {!noDivider && (
                <Divider sx={{ marginY: 2 }} textAlign="center">
                    Cidade de trabalho
                </Divider>
            )}
            <Grid container columns={24} spacing={1} columnSpacing={2}>
                <Grid item xs={10}>
                    <UFFuncionario />
                </Grid>
                <Grid item xs={14}>
                    <CidadeFuncionario />
                </Grid>
            </Grid>
        </section>
    )
}
